import * as React from "react";
import { SaveButton, DeleteWithConfirmButton, Toolbar } from "react-admin";

export const ActiveEditToolbar = props => (
  <Toolbar
    {...props}
    sx={{ display: "flex", justifyContent: "space-between" }}
  >
    <SaveButton alwaysEnable />
    <DeleteWithConfirmButton />
  </Toolbar>
);

export const ActiveCreateToolbar = props => (
  <Toolbar
    {...props}
    sx={{ display: "flex", justifyContent: "space-between" }}
  >
    <SaveButton alwaysEnable />
  </Toolbar>
);
